<template>
  <v-card>
    <v-card-text class="pt-0 pb-0">
      <v-form ref="register_form">
          <v-container>
          <v-row>
            <v-col>
              <v-alert
                v-model="alert"
                type="error"
                close-text="Close"
                dismissible
              >{{ errorMessage }}</v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="sm" sm="6" class="py-0">
              <v-text-field class="py-0"
                label="First Name"
                name="firstname"
                id="firstname"
                v-model="firstname"
                type="text"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="sm" sm="6" class="py-0">
              <v-text-field class="py-0"
                label="Last Name"
                name="lastname"
                id="lastname"
                v-model="lastname"
                type="text"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="sm" sm="12" class="py-0">
              <v-text-field class="py-0"
                label="E-Mail"
                name="username"
                id="username"
                v-model="username"
                type="text"
                :rules="[rules.required, rules.email]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="sm" sm="6" class="py-0">
              <v-text-field class="py-0"
                id="password"
                label="Password"
                name="password"
                v-model="password"
                :type="show_pwd ? 'text' : 'password'"
                :append-icon="show_pwd ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.password_length]"
                hint="Mininmum 6 characters"
                persistent-hint
                @click:append="show_pwd = !show_pwd"
              ></v-text-field>
                  </v-col>
                  <v-col cols="sm" sm="6" class="py-0">
              <v-text-field class="py-0"
                id="repeat_password"
                label="Repeat Password"
                name="repeat_password"
                v-model="repeat_password"
                :type="show_repeat_pwd ? 'text' : 'password'"
                :append-icon="show_repeat_pwd ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, passwordConfirmationRule]"
                @click:append="show_repeat_pwd = !show_repeat_pwd"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="sm" sm="12" class="py-0">
              <v-checkbox class="py-0"
                v-model="terms_agreed"
                label="I have read and accept the Terms and Conditions and Privacy Policy located in the footer of this website"
                persistent-hint
                :rules="[rules.required]"
                color="secondary"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="py-0"></v-col>
            <v-col class="py-0">
              <vue-recaptcha
                ref="ecaptcha"
                @verify="onVerify"
                @expired="onExpired"
                :sitekey="sitekey"
                :loadRecaptchaScript="true"
                v-if="showCaptcha"
                class="recaptcha text-center">
              </vue-recaptcha>
            </v-col>
            <v-col class="py-0"></v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('closeLogin')">Cancel</v-btn>
      <v-btn color="primary" @click="onRegister" :loading="loading">Register</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import { types as UserStoreTypes } from "../store/user";
export default {
  props: {
    source: String
  },
  data: () => ({    
    firstname: '',
    lastname: '',
    //membership_no: '12345',
    terms_agreed: true,

    username: '',
    password: '',
    repeat_password: '',
    sitekey: '6LcSQLEUAAAAACgW6Rbx5nuiPSsIrWBh2syUk_u0',//'6Lc5P7EUAAAAAMljM3BwrnpM47K-hiRjeH2C8BT_'
    reCaptchaVerify: '',
    show_pwd: false,
    show_repeat_pwd: false,
    valid: false,
    alert: false,
    rules: {
      required: value => !!value || 'Required.',
      password_length: value => value.length >= 6 || 'At least 6 characters required',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      },
    }
  }),
  computed: {
    user() {
      return this.$store.getters[UserStoreTypes.getters.USER];
    },
    passwordConfirmationRule() {
      return () => (this.password === this.repeat_password) || 'Passwords don\'t match'
    },
    errorMessage() {
      if (this.$store.getters[UserStoreTypes.getters.ERROR_REGISTER] !== null) {
        return this.firebase_message(
          this.$store.getters[UserStoreTypes.getters.ERROR_REGISTER].code
        );
      } else {
        return "";
      }
    },
    loading() {
      return this.$store.getters[UserStoreTypes.getters.IS_REGISTERING];
    },
    showCaptcha() {
      if (this.$store.getters[UserStoreTypes.getters.ERROR_REGISTER]) {
        return (
          this.$store.getters[UserStoreTypes.getters.ERROR_REGISTER].code ==
          "auth/too-many-requests"
        );
      }
      return false;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$emit('closeLogin');
        // IS THIS RIGHT FOR REGISTER?
        this.$router.push("/account/orders");
      }
    },
    errorMessage(value) {
      if (value && value.length > 0)
      {
        this.alert = true;
      } else {
        this.alert = false;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit(UserStoreTypes.mutations.ERROR_REGISTER, null);
      }
    },
    loading() {
    },
    showCaptcha() {
    }
  },
  methods: {
    onVerify: function(response) {
      this.reCaptchaVerify = response;
      this.$store.commit(UserStoreTypes.mutations.ERROR_REGISTER, null);
    },
    onExpired: function() {},
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    onRegister() {
      if (this.$refs.register_form.validate()) {
        // Do the registration
        const user = {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.username,
          password: this.password,
          membership_no: this.membership_no
        }
        this.$store.dispatch(UserStoreTypes.actions.REGISTER_NEW_USER, user);
      }
    }
  },
  
  mounted() {
  },
  components: {
    'vue-recaptcha': VueRecaptcha
  }
};
</script>

<style scoped>
</style>
